// extracted by mini-css-extract-plugin
export default {"tip-picker":"M4QIEp","tipPicker":"M4QIEp","custom-amount-input":"g2kmFR","customAmountInput":"g2kmFR"};